import React, { useState, useEffect } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Footer from "../../component/Footer/Footer";
import "./pgmdetails.scss";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import { decode } from "base-64";
import { safeDecode } from "../../common/decoder";
import {
  pgmdetailAction,
  approvalAction,
} from "../../actions/pgmAction";
import { Modal } from "react-bootstrap";
import Poppup from "../../component/Poppup/index";
import Collapsible from "react-collapsible";
import Loader from "../../component/loaderComponent/Loader";

function PgmDeactivateusers() {
  const [state, setDataState] = useState({  
    name: "",
    DOB: "",
    mobile_number: "",
    email: "",
    is_approve: "",
    profile: "",
    is_signup_completed: "",
    privacy_policy_accepted: "",
    type_of_vehicle: "",
    name_of_business: "",
    name_as_per_business_record: "",
    gps_address: "",
    postal_code: "",
    city: "",
    province: "",
    reference_type: "",
    name: "",
    Address: "",
    postal_code: "",
    city_state_name: "",
    phone: "",
    gps_address: null,
    postal_code: null,
    city: null,
    province: null,
    deatiled_address: null,
    attachment: "",
    distributor: "",

    verification_address_proof: "",
    verification_bank_account_receipt: "",
    verification_rfc: "",
    verfication_constitutive_act: "",
    verification_upload_verification_id: "",

    store_photos: "",

    business_data_gps_address: "",
    business_data_postal_code: "",
    detailed_address: "",
    business_ref_Address: "",
    business_ref_city_state_name: "",
    business_ref_id: "",
    business_ref_name: "",
    business_ref_phone: "",
    business_ref_postal_code: "",
    business_ref_reference_type: "",

    personal_ref_Address: "",
    personal_ref_city_state_name: "",
    personal_ref_id: "",
    personal_ref_name: "",
    personal_ref_phone: "",
    personal_ref_postal_code: "",
    personal_ref_reference_type: "",
  });
  const [pgmDetail, setPgmDetail] = useState([]);
  const[questionnaierdata,setQuestionnaierdata] = useState([]);
  const [collapse, setCollapse] = useState(false);
  const [collapsevehicle, setCollapseVehicle] = useState(false);
  const [collapsepersonal, setCollapsePersonal] = useState(false);
  const [collapsecommercial, setCollapsecommercial] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modaldetails, setmodaldetails] = useState({});
  const [modaldetailsbusiness, setmodaldetailsBusiness] = useState({});
  const [modaldetailsquestion, setmodaldetailsQuestion] = useState({});

  const [collapses, setCollapses] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
  };

  const handelCollpase = (param) => {
    setCollapse(!collapse);
  };
  const handelCollpases = (param) => {
    setCollapses(!collapses);
  };

  const handelCollpasesvehicle = (param) => {
    setCollapseVehicle(!collapsevehicle);
  };

  const handelCollpasescommercial = (param) => {
    setCollapsecommercial(!collapsecommercial);
  };
  const handelCollpasespersonal = (param) => {
    setCollapsePersonal(!collapsepersonal);
  };
  const [checkedItems, setCheckedItems] = useState({});
  const anyCheckboxChecked = Object.values(checkedItems).some((value) => value);

  const handleCheckboxChange = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.id]: event.target.checked,
    });

    // Determine which state to update based on the id
    if (event.target.id.startsWith("profile")) {
      // Update modaldetails for profile data
      setmodaldetails({
        ...modaldetails,
        [event.target.name]: event.target.value,
      });
    } else if (event.target.id.startsWith("businessinput")) {
      // Update modaldetailsbusiness for business input data
      setmodaldetailsBusiness({
        ...modaldetailsbusiness,
        [event.target.name]: event.target.value,
      });
    } else if (event.target.id.startsWith("questionaire")) {
      const updatedModaldetailsquestion = {
        ...modaldetailsquestion,
      };
      const Ques_data = questionnaierdata.map((data) => {
        return {
          question: data.question, 
          answer: data.answer,
        };
      });
  
      Ques_data.forEach((question) => {
        updatedModaldetailsquestion[question.question] = question.answer;
      });
  
      setmodaldetailsQuestion(updatedModaldetailsquestion);
    }
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    PgmDetailData();
  }, []);

  const { id } = useParams();
  const decodeid = safeDecode(id);

  async function PgmDetailData() {
    setIsLoading(true);
    let response = await dispatch(pgmdetailAction(decodeid));
    if (response == 200 || response != null) {
      setIsLoading(false);
      setQuestionnaierdata(response.data.data.user_data.questionnaier_data)
      setPgmDetail(response.data.data);
      setDataState({
        name: response.data.data.user_data.name,
        DOB: response.data.data?.user_data?.DOB,
        mobile_number: response.data.data?.user_data?.mobile_number,
        email: response.data.data?.user_data?.email,
        is_approve: response.data.data?.user_data?.is_approve,
        profile: response.data.data?.user_data?.profile,
        is_signup_completed: response.data.data?.user_data?.is_signup_completed,
        privacy_policy_accepted:
          response.data.data?.user_data?.privacy_policy_accepted,
        type_of_vehicle:
          response.data.data.user_data?.business_data?.type_of_vehicle,
        name_of_business:
          response.data.data?.user_data.business_data?.name_of_business,
        name_as_per_business_record:
          response.data.data?.user_data.business_data
            ?.name_as_per_business_record,
        deatiled_address:
          response.data.data?.user_data.business_data?.detailed_address,
        business_data_postal_code:
          response.data.data?.user_data.business_data?.postal_code,
        gps_address: response.data.data?.user_data.business_data?.gps_address,
        postal_code: response.data.data?.user_data.business_data?.postal_code,
        city: response.data.data?.user_data?.business_data?.city,
        province: response.data.data?.user_data.business_data?.province,
        distributor: response.data.data.user_data?.business_data?.distributor,
        detailed_address:
          response.data.data.user_data.business_data.detailed_address,
        business_data_previously_trained_by_tvs:
          response.data.data.user_data.business_data.previously_trained_by_tvs,
        business_data_province:
          response.data.data.user_data.business_data.province,
        business_data_gps_address:
          response.data.data.user_data.business_data.gps_address,
        verification_address_proof:
          response.data.data.user_data.business_data.address_proof,
        verification_bank_account_receipt:
          response.data.data.user_data.business_data.bank_account_receipt,
        verification_rfc: response.data.data.user_data.business_data.rfc,
        verfication_constitutive_act:
          response.data.data.user_data.business_data.constitutive_act,
        verification_upload_verification_id:
          response.data.data.user_data.constitutive_act,
        business_ref_Address:
          response.data.data.user_data?.business_references[0]?.Address,
        business_ref_city_state_name:
          response.data.data.user_data?.business_references[0]?.city_state_name,
        business_ref_id:
          response.data.data.user_data?.business_references[0]?.id,
        business_ref_name:
          response.data.data.user_data?.business_references[0]?.name,
        business_ref_phone:
          response.data.data.user_data?.business_references[0]?.phone,
        business_ref_postal_code:
          response.data.data.user_data?.business_references[0]?.postal_code,
        business_ref_reference_type:
          response.data.data.user_data?.business_references[0]?.reference_type,
        personal_ref_Address:
          response.data.data.user_data?.delivery_address[0]?.deatiled_address,
        personal_ref_city_state_name:
          response.data.data.user_data?.delivery_address[0]?.city,
        personal_ref_id: response.data.data.user_data?.delivery_address[0]?.id,
        personal_ref_name:
          response.data.data.user_data?.delivery_address[0]?.deatiled_address,
        personal_ref_phone:
          response.data.data.user_data?.delivery_address[0]?.deatiled_address,
        personal_ref_postal_code:
          response.data.data.user_data?.delivery_address[0]?.postal_code,
        personal_ref_reference_type:
          response.data.data.user_data?.delivery_address[0]?.deatiled_address,
        store_photos: response.data.data.user_data.store_photos[0].attachment,
      
      });
    }
  }
  const onapproval = async () => {
    let apiReq = {
      is_approve: "true",
    };
    setIsLoading(true);
    let response = await dispatch(approvalAction(apiReq, decodeid));
    if (response == 200 || response != null) {
      setIsLoading(false);
      NotificationManager.success(response.data.msg);
      navigate("/pgmlist");
    }
  };

  const onNeedCorrection = async () => {
    setShow(true);
  };

  const onclose = () => {
    window.scroll(0, 0);
    navigate("/pgmlist");
  };

  const [activeTab, setActiveTab] = useState("Vehicle Sales Partner");

  const handleTabToggle = (tabName) => {
    setActiveTab(tabName === activeTab ? null : tabName);
  };

  return (
    <div className="deactivate_containers_pgm">
      <div className="pgmcontainers_details">
        <div className="pgmdetails_container">
          <div className="pgmdetails pgm_details_container_s">
            <div className="header_border">
              <img src={Image_Url.TVSDASHBOARD} />
            </div>
            {isLoading ? (
              <Loader />
            ) : (
              <div>
                <div className="pgmdetails_textbuttons">
                  <span className="details_text">
                    Profile Details of DD PM Motors
                    <button className="pgmactive-deactivate">Active</button>
                  </span>
                  <div className="pgmdetails_allbutoons">
                    <button
                      className="details_close cursor-pointer"
                      onClick={onclose}
                    >
                      Close
                    </button>
                    <button
                      className="details_approved cursor-pointer"
                      onClick={onapproval}
                      disabled={state.is_approve}
                    >
                      Approved
                    </button>
                    <button
                      className="details_need cursor-pointer"
                      disabled={!anyCheckboxChecked}
                      onClick={() => onNeedCorrection()}
                    >
                      Deactivate This User
                    </button>
                  </div>
                </div>
                {/* <div className="pgmdetails_firstpara_Please">
                  <span className="pgmdetails_firstpara_text_Please">
                    Please select fields that you feel are not filled correctly.
                  </span>
                </div> */}
                <div className="pgmdetails_firstpara-deactivate">
                  <span className="pgmdetails_firstpara_text">
                    <input
                      type="checkbox"
                      className="checkbox"
                      name="name"
                      id="checkbox1"
                      checked={checkedItems["checkbox1"] || false}
                      onChange={handleCheckboxChange}
                    />
                    Service Center Partner, Spare Parts Partner and Vehicle
                    Sales Partner
                  </span>
                  <button className="change-role-deactivate">Change Role</button>
                </div>
                <div className="Pgm_Profile_details">
                  <span className="profile_text">Profile Details</span>
                  <img src={Image_Url.BORDER} />
                </div>
                <div className="profile_pgm_details">
                  <div className="profilepgm_profileicons">
                    <img
                      className="profile_img"
                      src={
                        state.profile == ""
                          ? Image_Url.PGMDETAILSICONS
                          : state.profile
                      }
                    />
                  </div>
                  <div className="profile_iconstext">
                    <div className="Profile_icon_border">
                      <div className="Profile_icon_text_profiledetails">
                        <div className="checkbox_div">
                          <input
                            type="checkbox"
                            className="checkbox"
                            name="Name"
                            value={state.name}
                            id="profile_name"
                            checked={checkedItems["profile_name"] || false}
                            onChange={handleCheckboxChange}
                          />
                          <div>
                            <span className="Profile_icon_text_span">Name</span>
                            <p className="Profile_icon_text_para">
                              {state.name}
                            </p>
                          </div>
                        </div>
                        <div className="checkbox_div">
                          <input
                            type="checkbox"
                            className="checkbox"
                            name="DOB"
                            value={state.DOB}
                            id="profile_DOB"
                            checked={checkedItems["profile_DOB"] || false}
                            onChange={handleCheckboxChange}
                          />
                          <div>
                            <span className="Profile_icon_text_span">
                              Date Of birth
                            </span>
                            <p className="Profile_icon_text_para">
                              {state.DOB}
                            </p>
                          </div>
                        </div>
                        <div className="checkbox_div">
                          <input
                            type="checkbox"
                            className="checkbox"
                            id="profile_mobile_number"
                            name="Mobile Number"
                            value={state.mobile_number}
                            checked={
                              checkedItems["profile_mobile_number"] || false
                            }
                            onChange={handleCheckboxChange}
                          />
                          <div>
                            <span className="Profile_icon_text_span">
                              Mobile Number
                            </span>
                            <p className="Profile_icon_text_para">
                              {state.mobile_number}
                              <span className="googlemaptext">Change</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="Profilepgmdetails_email">
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="profile_email"
                        name="Email Id"
                        value={state.email}
                        checked={checkedItems["profile_email"] || false}
                        onChange={handleCheckboxChange}
                      />
                      <div>
                        <span className="Profile_icon_text_span">Email Id</span>
                        <p className="Profile_icon_text_para">{state.email}</p>
                      </div>
                    </div>
                  </div>
                </div>
                {pgmDetail.user_data?.questionnaier_data.length > 0 ? (
                  <div>
                    <div className="Pgm_Profile_questionaire">
                      <span className="profile_text">
                        Questionnaire Details
                      </span>
                      <img src={Image_Url.BORDER} />
                    </div>

                    {/* <div className="pgm_details_parathird">
                  <span>Service Center Partner</span>
                  <img src={Image_Url.PGMDETAILS_ADDICON} />
                </div> */}

                    <div className="pgm_details_parafourth">
                      {/* <Collapsible trigger=" Service Center Partner" className="pgm_details_parafourth_textspare">  */}

                      <div>
                        <div className="pgm_details_parafourth_textspare">
                          <p className="pgm_details_parafourth_textsparespans">
                            <input
                              type="checkbox"
                              className="checkbox"
                              id="questionaire_Service Center Partner"
                              value="Yes"
                              checked={
                                checkedItems["questionaire_Service Center Partner"] || false
                              }
                              onChange={handleCheckboxChange}
                            />
                            Service Center Partner
                          </p>
                          {collapse === true ? (
                            <img
                              onClick={() => handelCollpase()}
                              src={Image_Url.PGMDETAILSMINUSICONS}
                            />
                          ) : (
                            <img
                              onClick={() => handelCollpase()}
                              src={Image_Url.OPEN_IMG}
                            />
                          )}
                        </div>
                      </div>
                      {collapse && (
                        <div>
                          <div className="Profile_icon_text">
                            {questionnaierdata.map((data)=>
                            <div className="profile_commercial">
                              <span className="Profile_icon_text_span">
                                {data.question}
                              </span>
                              <p className="Profile_icon_text_para">
                                {data.answer}
                              </p>
                            </div>)}
                            {/* <div className="profile_commercials">
                              <span className="Profile_icon_text_span">
                                Experience you have in the service center
                              </span>
                              <p className="Profile_icon_text_para">
                                Yes, 3 Years
                              </p>
                            </div>
                          </div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercial">
                              <span className="Profile_icon_text_span">
                                Have mechanics
                              </span>
                              <p className="Profile_icon_text_para">Yes</p>
                            </div>
                            <div className="profile_commercials">
                              <span className="Profile_icon_text_span">
                                Have ramps
                              </span>
                              <p className="Profile_icon_text_para">Yes</p>
                            </div>
                          </div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercial">
                              <span className="Profile_icon_text_span">
                                Have experience assembling motorcycles
                              </span>
                              <p className="Profile_icon_text_para">Yes</p>
                            </div>
                            <div className="profile_commercials">
                              <span className="Profile_icon_text_span">
                                Responded to warranty requests
                              </span>
                              <p className="Profile_icon_text_para">Yes</p>
                            </div> */}
                          </div>
                        </div>
                      )}

                      {/* </Collapsible> */}
                    </div>

                    <div className="pgm_details_parafourth">
                      <div className="pgm_details_parafourth_textspare">
                        <p className="pgm_details_parafourth_textsparespans">
                          <input type="checkbox" className="checkbox" />
                          Spare Parts Partner
                        </p>
                        {collapses === true ? (
                          <img
                            className="Collapsible__trigger"
                            src={Image_Url.PGMDETAILSMINUSICONS}
                            onClick={() => handelCollpases()}
                          />
                        ) : (
                          <img
                            src={Image_Url.OPEN_IMG}
                            onClick={() => handelCollpases()}
                          />
                        )}
                      </div>

                      {collapses && (
                        <div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercial">
                              <span className="Profile_icon_text_span">
                                Commercial space for the exhibition of spare
                                parts
                              </span>
                              <p className="Profile_icon_text_para">
                                Yes, 70 Square Meter
                              </p>
                            </div>
                            <div className="profile_commercials">
                              <span className="Profile_icon_text_span">
                                Experience of selling spare parts and counter
                              </span>
                              <p className="Profile_icon_text_para">11 Years</p>
                            </div>
                          </div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercial">
                              <span className="Profile_icon_text_span">
                                No. of spare parts sales executives
                              </span>
                              <p className="Profile_icon_text_para">5</p>
                            </div>
                            <div className="profile_commercials">
                              <span className="Profile_icon_text_span">
                                Your monthly sales goal
                              </span>
                              <p className="Profile_icon_text_para">
                                10,000 Peso
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="pgm_details_parafourth">
                      {/* <Collapsible
                    trigger="Vehicle Sales Partner"
                    className="pgm_details_parafourth_textspare"
                  > */}
                      {/* <Collapsible
                        trigger={
                          <span className="pgm-details-pgmlist">
                            <input
                              type="checkbox"
                              className="checkbox"
                              id=" Vehicle Sales Partner"
                              checked={
                                checkedItems[" Vehicle Sales Partner"] || false
                              }
                              onChange={handleCheckboxChange}
                            />
                            Vehicle Sales Partner
                            <img
                              className="page_minimizes"
                              src={Image_Url.OPEN_IMG}
                            />
                          </span>
                        }
                        open={activeTab === " Vehicle Sales Partner"}
                        onOpening={() =>
                          handleTabToggle(" Vehicle Sales Partner")
                        }
                        triggerWhenOpen={
                          <span>
                            <img
                              className="page_minimize2s"
                              src={Image_Url.PGMDETAILSMINUSICONS}
                            />
                          </span>
                        }
                        triggerWhenClosed={
                          <span>
                            <img
                              className="page_minimizes"
                              src={Image_Url.OPEN_IMG}
                            />
                          </span>
                        }
                        // trigger="Questionnaire For Spare Parts Partner"
                        className="partnerspara_tens_span"
                      > */}

                      <div className="pgm_details_parafourth_textspare">
                        <span>
                          <input
                            type="checkbox"
                            className="checkbox"
                            id=" Vehicle Sales Partner"
                            checked={
                              checkedItems[" Vehicle Sales Partner"] || false
                            }
                            onChange={handleCheckboxChange}
                          />
                          Vehicle Sales Partner
                        </span>
                        {collapsevehicle === true ? (
                          <img
                            className="Collapsible__trigger"
                            src={Image_Url.PGMDETAILSMINUSICONS}
                            onClick={() => handelCollpasesvehicle()}
                          />
                        ) : (
                          <img
                            src={Image_Url.OPEN_IMG}
                            onClick={() => handelCollpasesvehicle()}
                          />
                        )}
                      </div>
                      {collapsevehicle && (
                        <div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercial">
                              <span className="Profile_icon_text_span">
                                Commercial space for vehicle display
                              </span>
                              <p className="Profile_icon_text_para">
                                Yes, 70 Square Meter
                              </p>
                            </div>
                            <div className="profile_commercials">
                              <span className="Profile_icon_text_span">
                                Experience in selling vehicle
                              </span>
                              <p className="Profile_icon_text_para">
                                Yes, 3 Years
                              </p>
                            </div>
                          </div>
                          <div className="Profile_icon_text">
                            <div className="profile_commercial">
                              <span className="Profile_icon_text_span">
                                No. of sales executives
                              </span>
                              <p className="Profile_icon_text_para">5</p>
                            </div>
                            <div className="profile_commercials">
                              <span className="Profile_icon_text_span"></span>
                              <p className="Profile_icon_text_para"></p>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* </Collapsible> */}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="Pgm_Profile_businees">
                  <span className="profile_text">Business Contact</span>
                  <img src={Image_Url.BORDER} />
                </div>
                <div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_type_of_vehicle"
                          name="Type of vehicle dealing with"
                          value={state.type_of_vehicle}
                          checked={
                            checkedItems["businessinput_type_of_vehicle"] ||
                            false
                          }
                          onChange={handleCheckboxChange}
                        />

                        <div>
                          <span className="Profile_icon_text_span">
                            Type of vehicle dealing with
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.type_of_vehicle}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_Distributor"
                          name="Distributor"
                          value={state?.distributor}
                          checked={
                            checkedItems["businessinput_Distributor"] || false
                          }
                          onChange={handleCheckboxChange}
                        />
                        <div>
                          <span className="Profile_icon_text_span">
                            Distributor
                          </span>
                          <p className="Profile_icon_text_para">
                            {state?.distributor}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_Business/ organization"
                          name="Business/ organization"
                          value={state.name_of_business}
                          checked={
                            checkedItems["businessinput_Business/ organization"] || false
                          }
                          onChange={handleCheckboxChange}
                        />
                        <div>
                          <span className="Profile_icon_text_span">
                            Business/ organization
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.name_of_business}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_Name as per business record"
                          name="Name as per business record"
                          value={state.name_as_per_business_record}
                          checked={checkedItems["businessinput_Name as per business record"] || false}
                          onChange={handleCheckboxChange}
                        />
                        <div>
                          <span className="Profile_icon_text_span">
                            Name as per business record
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.name_as_per_business_record}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_CompleteAddress"
                          name="Complete Address"
                          value={state.detailed_address}
                          checked={checkedItems["businessinput_CompleteAddress"] || false}
                          onChange={handleCheckboxChange}
                        />
                        <div>
                          <span className="Profile_icon_text_span">
                            Complete Address
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.deatiled_address}
                            <span className="googlemaptext">
                              View on google map
                            </span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_City"
                          name="City"
                          value={state.city}
                          checked={checkedItems["businessinput_City"] || false}
                          onChange={handleCheckboxChange}
                        />
                        <div>
                          <span className="Profile_icon_text_span">City</span>
                          <p className="Profile_icon_text_para">{state.city}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="businessinput_PostalCode"
                          name="Postal Code"
                          value={state.business_data_postal_code}
                          checked={checkedItems["businessinput_PostalCode"] || false}
                          onChange={handleCheckboxChange}
                        />
                        <div>
                          <span className="Profile_icon_text_span">
                            Postal Code
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_data_postal_code}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="profile_commercials">
                      <div className="checkbox_div">
                        {/* <input type="checkbox" className="checkbox" id="checkbox13"
                    checked={checkedItems['checkbox13'] || false}
                    onChange={handleCheckboxChange} /> */}
                        <div>
                          <span className="Profile_icon_text_span">
                            Received training by TVS
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_data_previously_trained_by_tvs ===
                            true
                              ? "Yes"
                              : "No"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="Profile_icon_text">
                    <div className="profile_commercial">
                      <div className="checkbox_div">
                        <input
                          type="checkbox"
                          className="checkbox"
                          id="checkbox14"
                          checked={checkedItems["checkbox14"] || false}
                          onChange={handleCheckboxChange}
                        />
                        <div>
                          <span className="Profile_icon_text_span">
                            Province/ State
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_data_province}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pgmdetails_parasix">
                  <span className="pgmdetails_sixspan">
                    Using same address for delivery address
                  </span>
                </div>
                <div className="Pgm_Profile_verification">
                  <span className="profile_text">Verification</span>
                  <img src={Image_Url.BORDER} />
                </div>
                <div className="pgm_details_sevenpara">
                  <div className="veryfication_img">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="checkbox15"
                        checked={checkedItems["checkbox15"] || false}
                        onChange={handleCheckboxChange}
                      />
                      <img src={Image_Url.VERIFICATIONIDTYPE} />
                    </span>

                    <img
                      className="veryfication_images"
                      src={
                        state.verification_upload_verification_id
                          ? state.verification_upload_verification_id
                          : Image_Url.VERIFICATIONID
                      }
                    />
                  </div>
                  <div className="veryfication_img">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="checkbox16"
                        checked={checkedItems["checkbox16"] || false}
                        onChange={handleCheckboxChange}
                      />
                      Constitutive Act.
                    </span>
                    <img
                      className="veryfication_images"
                      src={
                        state.verfication_constitutive_act
                          ? state.verfication_constitutive_act
                          : Image_Url.VERIFICATIONID
                      }
                    />
                  </div>
                  <div className="veryfication_img">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="checkbox17"
                        checked={checkedItems["checkbox17"] || false}
                        onChange={handleCheckboxChange}
                      />
                      RFC.(Tax ID)
                    </span>
                    <img
                      className="veryfication_images"
                      src={
                        state.verification_rfc
                          ? state.verification_rfc
                          : Image_Url.VERIFICATIONID
                      }
                    />
                  </div>
                  <div className="veryfication_img">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="checkbox18"
                        checked={checkedItems["checkbox18"] || false}
                        onChange={handleCheckboxChange}
                      />
                      Proof of address.
                    </span>
                    <img
                      className="veryfication_images"
                      src={
                        state.verification_address_proof
                          ? state.verification_address_proof
                          : Image_Url.VERIFICATIONID
                      }
                    />
                  </div>
                </div>
                <div className="pgm_details_sevenparas">
                  <div className="veryfication_img">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="checkbox19"
                        checked={checkedItems["checkbox19"] || false}
                        onChange={handleCheckboxChange}
                      />
                      Bank account receipt
                    </span>
                    <img
                      className="veryfication_images"
                      src={
                        state.verification_bank_account_receipt
                          ? state.verification_bank_account_receipt
                          : Image_Url.VERIFICATIONID
                      }
                    />
                  </div>
                  <div className="veryfication_img">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="checkbox20"
                        checked={checkedItems["checkbox20"] || false}
                        onChange={handleCheckboxChange}
                      />
                      Other
                    </span>
                    <img src={Image_Url.VERIFICATIONID} />
                  </div>
                </div>

                <div className="checkbox_divs">
                  <input
                    type="checkbox"
                    className="checkbox"
                    id="checkbox21"
                    checked={checkedItems["checkbox21"] || false}
                    onChange={handleCheckboxChange}
                  />
                  <span>Photos of your store</span>
                </div>
                <div className="pgm_details_eight_paras">
                  <div className="veryfication_img">
                    <span></span>
                    <img
                      className="store-img"
                      src={
                        state.store_photos
                          ? state.store_photos
                          : Image_Url.STORES1
                      }
                    />
                  </div>
                </div>
                <div className="commercial"></div>
               
                <div className="pgm_details_parafourth">
                  {/* <Collapsible
                    trigger={
                      <span>
                        Commercial References
                        <img
                          className="page_minimizes"
                          src={Image_Url.OPEN_IMG}
                        />
                      </span>
                    }
                    open={activeTab === "Commercial References"}
                    onOpening={() => handleTabToggle(" Commercial References")}
                    triggerWhenOpen={
                      <span>
                        <img
                          className="page_minimize2s"
                          src={Image_Url.PGMDETAILSMINUSICONS}
                        />
                      </span>
                    }
                    triggerWhenClosed={
                      <span>
                        <img
                          className="page_minimizes"
                          src={Image_Url.OPEN_IMG}
                        />
                      </span>
                    }
                    // trigger="Questionnaire For Spare Parts Partner"
                    className="partnerspara_tens_span"
                  > */}

                  {/* <Collapsible
                    trigger="Commercial References"
                    className="pgm_details_parafourth_textspare"
                  > */}
                  <div className="pgm_details_parafourth_textspare">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id="Commercial References"
                        checked={checkedItems["Commercial References"] || false}
                        onChange={handleCheckboxChange}
                      />
                      Commercial References
                    </span>
                    {collapsecommercial === true ? (
                      <img
                        className="Collapsible__trigger"
                        src={Image_Url.PGMDETAILSMINUSICONS}
                        onClick={() => handelCollpasescommercial()}
                      />
                    ) : (
                      <img
                        src={Image_Url.OPEN_IMG}
                        onClick={() => handelCollpasescommercial()}
                      />
                    )}
                  </div>
                  {collapsecommercial && (
                    <div>
                      <div className="Profile_icon_text">
                        <div className="profile_commercial">
                          <span className="Profile_icon_text_span">Name</span>
                          <p className="Profile_icon_text_para">
                            {state.business_ref_name}
                          </p>
                        </div>
                        <div className="profile_commercials">
                          <span className="Profile_icon_text_span">
                            Address
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_ref_Address}
                            <span className="googlemaptext">
                              View on google map
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="Profile_icon_text">
                        <div className="profile_commercial">
                          <span className="Profile_icon_text_span">
                            Postal Code
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_ref_postal_code}
                          </p>
                        </div>
                        <div className="profile_commercials">
                          <span className="Profile_icon_text_span">
                            City / State
                          </span>
                          <p className="Profile_icon_text_para">
                            {state.business_ref_city_state_name}
                          </p>
                        </div>
                      </div>
                      <div className="Profile_icon_text">
                        <div className="profile_commercial">
                          <span className="Profile_icon_text_span">Phone</span>
                          <p className="Profile_icon_text_para">
                            {state.business_ref_phone}
                          </p>
                        </div>
                        <div className="profile_commercials">
                          <span className="Profile_icon_text_span"></span>
                          <p className="Profile_icon_text_para"></p>
                        </div>
                      </div>
                      {/* </Collapsible> */}
                    </div>
                  )}
                </div>
                <div className="pgm_details_parafourth">
                  {/* <Collapsible
                    trigger={
                      <span>
                        Personal References
                        <img
                          className="page_minimizes"
                          src={Image_Url.OPEN_IMG}
                        />
                      </span>
                    }
                    open={activeTab === "Personal References"}
                    onOpening={() => handleTabToggle(" Personal References")}
                    triggerWhenOpen={
                      <span>
                        <img
                          className="page_minimize2s"
                          src={Image_Url.PGMDETAILSMINUSICONS}
                        />
                      </span>
                    }
                    triggerWhenClosed={
                      <span>
                        <img
                          className="page_minimizes"
                          src={Image_Url.OPEN_IMG}
                        />
                      </span>
                    }
                    // trigger="Questionnaire For Spare Parts Partner"
                    className="partnerspara_tens_span"
                  > */}
                  {/* <Collapsible
                    trigger="Personal References"
                    className="pgm_details_parafourth_textspare"
                  > */}

                  <div className="pgm_details_parafourth_textspare">
                    <span>
                      <input
                        type="checkbox"
                        className="checkbox"
                        id=" Personal References"
                        checked={checkedItems[" Personal References"] || false}
                        onChange={handleCheckboxChange}
                      />
                      Personal References
                    </span>
                    {collapsepersonal === true ? (
                      <img
                        className="Collapsible__trigger"
                        src={Image_Url.PGMDETAILSMINUSICONS}
                        onClick={() => handelCollpasespersonal()}
                      />
                    ) : (
                      <img
                        src={Image_Url.OPEN_IMG}
                        onClick={() => handelCollpasespersonal()}
                      />
                    )}
                  </div>
                  {collapsepersonal === true && (
                    <div>
                      <div className="Profile_icon_text">
                        <div className="profile_commercial">
                          <span className="Profile_icon_text_span">Name</span>
                          <p className="Profile_icon_text_para">
                            Business name
                          </p>
                        </div>
                        <div className="profile_commercials">
                          <span className="Profile_icon_text_span">
                            Address
                          </span>
                          <p className="Profile_icon_text_para">
                            B-61, Rakshapuram, Raipur road
                            <span className="googlemaptext">
                              View on google map
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="Profile_icon_text">
                        <div className="profile_commercial">
                          <span className="Profile_icon_text_span">
                            Postal Code
                          </span>
                          <p className="Profile_icon_text_para">569874</p>
                        </div>
                        <div className="profile_commercials">
                          <span className="Profile_icon_text_span">
                            City / State
                          </span>
                          <p className="Profile_icon_text_para">City name</p>
                        </div>
                      </div>
                      <div className="Profile_icon_text">
                        <div className="profile_commercial">
                          <span className="Profile_icon_text_span">Phone</span>
                          <p className="Profile_icon_text_para">
                            +55 34 5452 3432
                          </p>
                        </div>
                        <div className="profile_commercials">
                          <span className="Profile_icon_text_span"></span>
                          <p className="Profile_icon_text_para"></p>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* </Collapsible> */}
                </div>
              </div>
            )}
          </div>
          <div className="details_pgm"></div>
          <Modal
            className="expertise-modal montserrat-font"
            show={show}
            onHide={handleClose}
          >
            <Modal.Body className="p-0">
              {checkedItems && (
                <Poppup
                  handleClose={handleClose}
                  modaldetail={modaldetails}
                  modaldetailsbusiness={modaldetailsbusiness}
                  modaldetailsquestion={modaldetailsquestion}
                  userid={decodeid}
                />
              )}
            </Modal.Body>
          </Modal>
        </div>
      </div>
      <div className="footer-div">
        <Footer />
      </div>
    </div>
  );
}

export default PgmDeactivateusers;
